import { render, staticRenderFns } from "./SocialResponsibilityView.vue?vue&type=template&id=39e1164c&"
import script from "./SocialResponsibilityView.vue?vue&type=script&lang=js&"
export * from "./SocialResponsibilityView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports